import React, { useState, useEffect } from 'react';
import api from '../services/api';
import axios from 'axios'; // TODO: rimuovere, usare api
import { Link } from 'react-router-dom';
import { PlusIcon, MagnifyingGlassIcon, ChevronLeftIcon, ChevronRightIcon, TrashIcon, PencilIcon, ShieldCheckIcon, IdentificationIcon } from '@heroicons/react/24/outline';
import SocietaNoleggioForm from './SocietaNoleggioForm';
import SocietaNoleggioDocumentiTemplate from './SocietaNoleggioDocumentiTemplate';

const SocietaNoleggioList = () => {
  const [societa, setSocieta] = useState([]);
  const [garanzie, setGaranzie] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [currentSocieta, setCurrentSocieta] = useState(null);
  const [search, setSearch] = useState('');
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [showIds, setShowIds] = useState(false);
  const [activeTab, setActiveTab] = useState('societa');
  const [filters, setFilters] = useState({
    tipiClientiAccettati: '',
    accettaPrivatiRedditoUnico: '',
    idGaranzie: '',
    mostraInattive: false
  });
  const [notification, setNotification] = useState({
    show: false,
    message: '',
    type: 'success',
    timeout: null
  });

  // Recupera l'elenco delle società di noleggio
  const fetchSocieta = async () => {
    try {
      setLoading(true);
      const params = {
        search,
        page: currentPage,
        limit: 10,
        ...filters
      };

      const response = await api.get('/noleggio/societanoleggio', { params });
      setSocieta(response.data.societa || []);
      setTotalPages(response.data.pagination?.totalPages || 1);
      setCurrentPage(response.data.pagination?.currentPage || 1);
      setLoading(false);
    } catch (err) {
      console.error('Errore nel recupero delle società di noleggio:', err);
      setError('Si è verificato un errore nel caricamento delle società di noleggio.');
      setLoading(false);
    }
  };

  // Recupera l'elenco delle garanzie
  const fetchGaranzie = async () => {
    try {
      const response = await api.get('/noleggio/garanzie');
      setGaranzie(response.data || []);
    } catch (err) {
      console.error('Errore nel recupero delle garanzie:', err);
      setNotification({
        show: true,
        message: 'Errore nel recupero delle garanzie',
        type: 'error',
        timeout: setTimeout(() => setNotification(prev => ({ ...prev, show: false })), 3000)
      });
    }
  };

  // Carica i dati all'avvio del componente
  useEffect(() => {
    fetchSocieta();
    fetchGaranzie();
  }, [currentPage, search, filters]);

  // Funzione per aprire il form di creazione
  const handleCreate = () => {
    setCurrentSocieta(null);
    setShowForm(true);
  };

  // Funzione per aprire il form di modifica
  const handleEdit = (societa) => {
    setCurrentSocieta(societa);
    setShowForm(true);
  };

  // Funzione per disattivare una società
  const handleDelete = async (id) => {
    if (!window.confirm('Sei sicuro di voler disattivare questa società di noleggio?')) {
      return;
    }

    try {
      await api.delete(`/noleggio/societanoleggio/${id}`);
      fetchSocieta();
      setNotification({
        show: true,
        message: 'Società di noleggio disattivata con successo',
        type: 'success',
        timeout: setTimeout(() => setNotification(prev => ({ ...prev, show: false })), 3000)
      });
    } catch (err) {
      console.error('Errore nella disattivazione della società di noleggio:', err);
      setNotification({
        show: true,
        message: 'Errore nella disattivazione della società di noleggio',
        type: 'error',
        timeout: setTimeout(() => setNotification(prev => ({ ...prev, show: false })), 3000)
      });
    }
  };

  // Gestione salvataggio dal form
  const handleSave = (data, isNew) => {
    fetchSocieta();
    setShowForm(false);
    setNotification({
      show: true,
      message: `Società di noleggio ${isNew ? 'creata' : 'aggiornata'} con successo`,
      type: 'success',
      timeout: setTimeout(() => setNotification(prev => ({ ...prev, show: false })), 3000)
    });
  };

  // Gestione filtri
  const handleFilterChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    setCurrentPage(1);
  };

  // Gestione paginazione
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="bg-gray-50 py-4">
      {/* Notifiche Toast */}
      {notification.show && (
        <div className={`fixed top-4 right-4 z-50 p-4 rounded-md shadow-lg ${
          notification.type === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
        }`}>
          <div className="flex justify-between items-center">
            <span>{notification.message}</span>
            <button
              onClick={() => setNotification({ ...notification, show: false })}
              className="ml-4 text-gray-400 hover:text-gray-600"
            >
              ×
            </button>
          </div>
        </div>
      )}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Gestione Società di Noleggio</h1>
            <p className="mt-1 text-sm text-gray-600">
              Gestisci le società di noleggio, le garanzie e i documenti template
            </p>
          </div>
              </div>

        {/* Tabs */}
        <div className="border-b border-gray-200 mb-4">
          <div className="flex">
            <button 
              className={`py-2 px-4 border-b-2 ${activeTab === 'societa' ? 'border-blue-500 text-blue-600 font-medium' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}
              onClick={() => setActiveTab('societa')}
            >
              Società di Noleggio
            </button>
            <button 
              className={`py-2 px-4 border-b-2 ${activeTab === 'documenti' ? 'border-blue-500 text-blue-600 font-medium' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}
              onClick={() => setActiveTab('documenti')}
            >
              Documenti Template
            </button>
          </div>
        </div>

        {/* Contenuto condizionale in base alla tab attiva */}
        {activeTab === 'societa' && (
          <>
            {/* Controlli e filtri */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 space-y-4 md:space-y-0">
              <div className="flex items-center space-x-4">
                <button
                  onClick={handleCreate}
                  className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 flex items-center"
                >
                  <PlusIcon className="h-5 w-5 mr-2" />
                  Nuova Società
                </button>
                
                <Link
                  to="/nlt/societa-noleggio/garanzie"
                  className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 flex items-center"
                >
                  <ShieldCheckIcon className="h-5 w-5 mr-2" />
                  Gestisci Garanzie
                </Link>
              </div>

              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  id="showIds"
                  checked={showIds}
                  onChange={(e) => setShowIds(e.target.checked)}
                  className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <label htmlFor="showIds" className="text-sm text-gray-700">
                  Mostra ID
                </label>
          </div>
        </div>

        {/* Filtri e ricerca */}
        <div className="mb-6 p-4 bg-white rounded-md shadow">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="relative">
              <input
                type="text"
                placeholder="Cerca per nome..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1);
                }}
                className="w-full p-2 pl-8 border border-gray-300 rounded"
              />
              <MagnifyingGlassIcon className="absolute left-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
            </div>

            <div>
              <select
                name="tipiClientiAccettati"
                value={filters.tipiClientiAccettati}
                onChange={handleFilterChange}
                className="w-full p-2 border border-gray-300 rounded"
              >
                <option value="">Tutti i tipi di clienti</option>
                <option value="Privati">Privati</option>
                <option value="Aziende">Aziende</option>
              </select>
            </div>

            <div>
              <select
                name="idGaranzie"
                value={filters.idGaranzie}
                onChange={handleFilterChange}
                className="w-full p-2 border border-gray-300 rounded"
              >
                <option value="">Tutte le garanzie</option>
                {garanzie.map(g => (
                  <option key={g.id} value={g.id}>{g.descrizione}</option>
                ))}
              </select>
            </div>

            <div className="flex items-center space-x-4">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="accettaPrivatiRedditoUnico"
                  name="accettaPrivatiRedditoUnico"
                  checked={filters.accettaPrivatiRedditoUnico === 'true'}
                  onChange={(e) => handleFilterChange({
                    target: {
                      name: 'accettaPrivatiRedditoUnico',
                      value: e.target.checked ? 'true' : '',
                      type: 'select'
                    }
                  })}
                  className="mr-2 h-4 w-4 text-blue-600"
                />
                <label htmlFor="accettaPrivatiRedditoUnico" className="text-sm">
                  Solo con reddito unico
                </label>
              </div>

              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="mostraInattive"
                  name="mostraInattive"
                  checked={filters.mostraInattive}
                  onChange={handleFilterChange}
                  className="mr-2 h-4 w-4 text-blue-600"
                />
                <label htmlFor="mostraInattive" className="text-sm">
                  Mostra inattive
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* Tabella società */}
        <div className="bg-white shadow-md rounded-md overflow-hidden">
          {loading ? (
            <div className="flex justify-center items-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-600"></div>
              <span className="ml-2 text-gray-600">Caricamento in corso...</span>
            </div>
          ) : error ? (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded relative" role="alert">
              <strong className="font-bold">Errore: </strong>
              <span className="block sm:inline">{error}</span>
            </div>
          ) : societa.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              <p className="text-lg">Nessuna società di noleggio trovata</p>
              <p className="text-sm mt-2">Aggiungi una nuova società o modifica i filtri di ricerca</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    {showIds && (
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        ID
                      </th>
                    )}
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Nome
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Tipi Clienti
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Reddito Unico
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Garanzie
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Stato
                    </th>
                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Azioni
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {societa.map((s) => (
                    <tr key={s.id} className={!s.attivo ? 'bg-gray-50' : ''}>
                      {showIds && (
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono">
                          {s.id}
                        </td>
                      )}
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        {s.nome}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {s.tipiClientiAccettati || '-'}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {s.accettaPrivatiRedditoUnico ? 'Sì' : 'No'}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {s.garanzie && s.garanzie.length > 0 ? (
                          <div>
                            {s.garanzie.map(g => (
                              <span key={g.id} className="inline-block bg-blue-50 text-blue-700 px-2 py-1 rounded-full text-xs mr-1 mb-1">
                                {g.descrizione}
                              </span>
                            ))}
                          </div>
                        ) : (
                          <span className="text-gray-400">Nessuna</span>
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm">
                        <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                          s.attivo ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                        }`}>
                          {s.attivo ? 'Attiva' : 'Inattiva'}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                        <button
                          onClick={() => handleEdit(s)}
                          className="text-blue-600 hover:text-blue-900 mr-4"
                        >
                          <PencilIcon className="h-5 w-5" />
                        </button>
                        {s.attivo && (
                          <button
                            onClick={() => handleDelete(s.id)}
                            className="text-red-600 hover:text-red-900"
                          >
                            <TrashIcon className="h-5 w-5" />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Paginazione */}
        {societa.length > 0 && totalPages > 1 && (
          <div className="flex justify-between items-center mt-4">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className={`px-4 py-2 border border-gray-300 rounded-md text-sm ${
                currentPage === 1 ? 'text-gray-400 cursor-not-allowed' : 'text-blue-600 hover:bg-gray-50'
              }`}
            >
              <ChevronLeftIcon className="h-5 w-5 inline" />
              Precedente
            </button>
            <div className="text-sm text-gray-700">
              Pagina <span className="font-medium">{currentPage}</span> di <span className="font-medium">{totalPages}</span>
            </div>
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className={`px-4 py-2 border border-gray-300 rounded-md text-sm ${
                currentPage === totalPages ? 'text-gray-400 cursor-not-allowed' : 'text-blue-600 hover:bg-gray-50'
              }`}
            >
              Successiva
              <ChevronRightIcon className="h-5 w-5 inline" />
            </button>
          </div>
            )}
          </>
        )}

        {/* Tab Documenti Template */}
        {activeTab === 'documenti' && (
          <SocietaNoleggioDocumentiTemplate />
        )}

        {/* Form modale per creazione/modifica */}
        {showForm && (
          <SocietaNoleggioForm
            societa={currentSocieta}
            garanzie={garanzie}
            onSave={handleSave}
            onCancel={() => setShowForm(false)}
          />
        )}
      </div>
    </div>
  );
};

export default SocietaNoleggioList; 